import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import * as LedgerActions from './actions';

import LedgerPage from './LedgerPage';

const LedgerPageContainer = ({
  dispatch,
  accounts,
  contracts,
  transactions,
  transactionStack,
  userId,
  changingMp,
  dealing,
  retrieved,
  retrievedW,
  confirmedDeal
}) => {
  const TIME_DELTA = 3600;

  const pathname = useLocation().pathname;
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.TkgGoldBuyingAndSelling;

  const [ dataKeyWcmp, setDataKeyWcmp ] = useState(null);
  const [ dataKeyGbsT, setDataKeyGbsT ] = useState(null);
  const [ dataKeyWill, setDataKeyWill ] = useState(null);
  const [ dataKeyUW, setDataKeyUW ] = useState(null);
  const [ dataKeyYt, setDataKeyYt ] = useState(null);
  const [ dataKeyGt, setDataKeyGt ] = useState(null);
  const [ dataKeyPal, setDataKeyPal ] = useState(null);
  const [ dataKeyMp, setDataKeyMp ] = useState(null);
  const [ updated, setUpdated ] = useState(false);
  const [ wcmp, setWcmp ] = useState(0);
  const [ yt, setYt ] = useState(null);
  const [ gt, setGt ] = useState(null);
  const [ pal, setPal ] = useState([]);
  const [ mp, setMp ] = useState([]);
  const [ isBalanceOver, setIsBalanceOver ] = useState(false);
  const [ gbsTransactions, setGbsTransactions ] = useState(null);
  const [ wills, setWills ] = useState(null);
  const [ fetched, setFetched ] = useState(false);
  const now = Date.now();
  const nowLowerBoundW = new Date(now - 60*60*24*7*1000).toLocaleString("ja");
  const nowUpperBoundW = new Date(now + 60*60*24*7*1000).toLocaleString("ja");
  const nowLowerBound = new Date(now - 60*60*24*7*1000).toLocaleString("ja");
  const nowUpperBound = new Date(now + 60*60*24*7*1000).toLocaleString("ja");
  const [ data, setData ] = useState({ startTime: nowLowerBound, endTime: nowUpperBound });
  const [ dataUW, setDataUW ] = useState({ startTime: nowLowerBound, endTime: nowUpperBound });
  const [ dataW, setDataW ] = useState({ amount: 0, priceForToken: 0 });

  const [ stackLen, setStackLen ] = useState(0);
  const [ wDStackId, setWDStackId ] = useState(0);
  const [ chMpStackId, setChMpStackId ] = useState(0);

  const [ dealType, setDealType ] = useState("TYPE");
  const [ open, setOpen ] = useState(false);

  const NODEALTYPE = 4;
  const [ willDealTokensModal, setWillDealTokensModal ] = useState(false);
  const [ willDealTokens, setWillDealTokens ] = useState({
    userId: 0,
    amount: 0,
    priceForToken: 0,
    dealType: NODEALTYPE
  });

  useEffect(() => {
    willChangeMarketPrice();
  }, []);

  useEffect(() => {
    if (!confirmedDeal)
      return;

    makeWillDealTokens(willDealTokens.userId, willDealTokens.amount, willDealTokens.priceForToken, willDealTokens.dealType);
  }, [confirmedDeal]);

  useEffect(() => {
    updateLedger();
  }, [pathname]);

  useEffect(() => {
    if (gbsTransactions === null || wills === null || yt === null || gt === null || pal.length === 0 || mp.length === 0)
      return;

    initLedger();
  }, [gbsTransactions, yt, gt, pal, mp]);

  useEffect(() => {
    showGbsTransactions(userId, data.startTime, data.endTime);
  }, [contracts.synced, changingMp]);

  useEffect(() => {
    if (gbsTransactions === null)
      return

    showWills(nowLowerBoundW, nowUpperBoundW);
  }, [gbsTransactions]);

  useEffect(() => {
    if (wills === null)
      return

    showBalanceYt();
    showBalanceGt();
  }, [wills]);

  useEffect(() => {
    if (yt === null || gt === null)
      return;

    showPal(userId);
  }, [yt, gt]);

  useEffect(() => {
    if (pal === [])
      return;

    showMp();
  }, [pal]);

  useEffect(() => {
    if (dataKeyWcmp === null && updated)
      return;

    fetchWillChangeMarketPrice();
  }, [contracts.willChangeMarketPrice, updated]);

  useEffect(() => {
    if (wcmp === 0 || Date.now()/1000 < (parseInt(wcmp)+TIME_DELTA) || changingMp)
      return;

    changeMarketPrice();
  }, [wcmp]);

  useEffect(() => {
    if (!retrieved && !updated && dataKeyGbsT === null)
      return;
   
    fetchGbsTransactions(dataKeyGbsT);
  }, [contracts.TkgGoldBuyingAndSelling.collectGbsTransaction, updated]);

  useEffect(() => {
    if (!retrievedW && !updated && dataKeyWill === null)
      return;
   
    fetchWills(dataKeyWill);
  }, [contracts.TkgGoldBuyingAndSelling.collectInfoOfWill, updated]);

  // FIXME There happens a large amount of process of this useEffect().
  useEffect(() => {
    if ((dataKeyYt === null || dataKeyGt === null) && !updated)
      return;

    fetchBalanceYt(dataKeyYt);
    fetchBalanceGt(dataKeyGt);
  }, [contracts.TkgGoldBuyingAndSelling.balanceOf, contracts.TkgGoldBuyingAndSelling.balanceOfV, updated]);

  useEffect(() => {
    if (dataKeyPal === null && !updated)
      return;

    fetchPal(dataKeyPal);
  }, [contracts.TkgGoldBuyingAndSelling.showProfitAndLoss, updated]);

  useEffect(() => {
    if (dataKeyMp === null && !updated)
      return;

    fetchMp();
  }, [contracts.TkgGoldBuyingAndSelling.showMarketPrice, updated]);
  
  useEffect(() => {
    var txHash = 0;
    const length = transactionStack.length;
    if (length === stackLen)
      return;

    if (changingMp)
      txHash = transactionStack[chMpStackId];
    else if (dealing)
      txHash = transactionStack[wDStackId];

    if (transactions[txHash] && transactions[txHash].status === 'pending' && transactions[txHash].confirmations.length === 0)
      setStackLen(length);
  }, [transactions]);

  useEffect(() => {
    try {
      if (transactionStack.length === 0)
        return;
  
      var txHash = 0;
  
      if (changingMp)
        txHash = transactionStack[chMpStackId];
      else if (dealing)
        txHash = transactionStack[wDStackId];
  
      if (changingMp && transactionStack.length > 0 && transactions[txHash].status === 'success') {
        dispatch(notifyChangingMp(false));
      } else if (dealing && transactionStack.length > 0 && transactions[txHash].status === 'success') {
        updateWills(nowLowerBoundW, nowUpperBoundW);
        setWillDealTokens({ userId: null, amount: null, priceForToken: null, dealType: null });
        setWillDealTokensModal(false);
        dispatch(notifyDealing(false));
        dispatch(committedDeal(false));
      }
    } catch(error) {
      console.error(error);
      dispatch(notifyChangingMp(false));
      setWillDealTokensModal(false);
      dispatch(notifyDealing(false));
      dispatch(committedDeal(false));
    }
  }, [transactions]);

  useEffect(() => {
    if (!retrievedW && !updated && dataKeyUW === null)
      return;

    fetchWills(dataKeyUW);
  }, [contracts.TkgGoldBuyingAndSelling.collectInfoOfWill, dataKeyUW]);

  const initLedger = () => {
    setFetched(true);
    setUpdated(false);
    dispatch(notifyChangingMp(false));
  }

  const updateLedger = () => {
    setFetched(false);
    setUpdated(true);
    //FIXME setDataKeyGbsT(null);
    dispatch(notifyChangingMp(false));
    showGbsTransactions(userId, data.startTime, data.endTime);
    showWills(nowLowerBoundW, nowUpperBoundW);
    showBalanceYt();
    showBalanceGt();
    showPal(userId);
    showMp();
  }

  const willChangeMarketPrice = async () => {
    const _dataKeyWcmp = await contract.methods.willChangeMarketPrice.cacheCall();
    setDataKeyWcmp(_dataKeyWcmp);
  }

  const changeMarketPrice = async () => {
    const estimatedGas = await contract.methods.changeMarketPrice(
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const gasMultiplication = 1.2;
    const gasPriceMultiplication = 1.2;

    const _stackId = await contract.methods.changeMarketPrice.cacheSend({
      from: accounts[0],
      gas: Math.floor(estimatedGas*gasMultiplication),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication)
    });

    dispatch(notifyChangingMp(true));
    setChMpStackId(_stackId);
  }

  const showGbsTransactions = async (_userId, _startTime, _endTime) => {
    if (_startTime === null || _endTime === null)
      return;

    const unixStartTime = Date.parse(_startTime) / 1000;
    const unixEndTime = Date.parse(_endTime) / 1000;

    var _dataKeyGbsT = await contract.methods.collectGbsTransaction.cacheCall(_userId, unixStartTime, unixEndTime)

    setDataKeyGbsT(_dataKeyGbsT);
  }

  const fetchGbsTransactions = _dataKeyGbsT => {
    var i = 0;
    var j = 0;
    var _gbsTransactions = [];
    var res = [];

    const cache =
      contracts.TkgGoldBuyingAndSelling.collectGbsTransaction[_dataKeyGbsT];

    res =
      Array.isArray(cache?.value)
        ? cache.value
        : [];

    for (i = 0; i < res.length; i++) {
      if (parseInt(res[i].transactionTime) > 0)
        _gbsTransactions[j++] = res[i];
    }

    _gbsTransactions = _gbsTransactions.sort((a, b) => { 
      return (a.transactionTime < b.transactionTime) ? 1 : -1;
    });
    setGbsTransactions(_gbsTransactions);
    dispatch(retrieveGt(true));

    return true;
  }

  const showWills = async (_startTime, _endTime) => {
    if (_startTime === null || _endTime === null)
      return;

    const unixStartTime = Date.parse(_startTime) / 1000;
    const unixEndTime = Date.parse(_endTime) / 1000;

    var _dataKey = await contract.methods.collectInfoOfWill.cacheCall(unixStartTime, unixEndTime)
    setDataKeyWill(_dataKey);
  }

  const updateWills = async (_startTime, _endTime) => {
    if (_startTime === null || _endTime === null)
      return;

    const unixStartTime = Date.parse(_startTime) / 1000;
    const unixEndTime = Date.parse(_endTime) / 1000;

    var _dataKey = await contract.methods.collectInfoOfWill.cacheCall(unixStartTime, unixEndTime)
    setDataKeyUW(_dataKey);
  }

  const fetchWills = _dataKey => {
    var i = 0;
    var j = 0;
    var _wills = [];
    var res = [];

    const cache =
      contracts.TkgGoldBuyingAndSelling.collectInfoOfWill[_dataKey];

    res =
      Array.isArray(cache?.value)
        ? cache.value
        : [];

    for (i = 0; i < res.length; i++) {
      if (parseInt(res[i].indicatedTime) > 0 && res[i].userAddr !== accounts[0])
        _wills[j++] = res[i];
    }

    _wills = _wills.sort((a, b) => {
      return (a.indicatedTime < b.indicatedTime ? 1 : -1);
    });
    setWills(_wills);
    dispatch(retrieveWills(true));

    return true;
  }

  const showBalanceYt = async () => {
    var _dataKeyYt = await contract.methods.balanceOfV.cacheCall(accounts[0]);
    setDataKeyYt(_dataKeyYt);
  }

  const showBalanceGt = async () => {
    var _dataKeyGt = await contract.methods.balanceOf.cacheCall(accounts[0]);
    setDataKeyGt(_dataKeyGt);
  }

  const showPal = async _userId => {
    var _dataKeyPal = await contract.methods.showProfitAndLoss.cacheCall(_userId);
    setDataKeyPal(_dataKeyPal);
  }

  const showMp = async () => {
    var _dataKeyMp = await contract.methods.showMarketPrice.cacheCall();
    setDataKeyMp(_dataKeyMp);
  }

  const fetchWillChangeMarketPrice = () => {
    var res = null;

    res = contracts.TkgGoldBuyingAndSelling.willChangeMarketPrice[dataKeyWcmp]
      ? contracts.TkgGoldBuyingAndSelling.willChangeMarketPrice[dataKeyWcmp].value
      : 0;

    setWcmp(res);
  }

  const fetchBalanceYt = () => {
    var res = null;

    res = contracts.TkgGoldBuyingAndSelling.balanceOfV[dataKeyYt]
      ? contracts.TkgGoldBuyingAndSelling.balanceOfV[dataKeyYt].value
      : null;

    setYt(res);
  }

  const fetchBalanceGt = () => {
    var res = null;

    res = contracts.TkgGoldBuyingAndSelling.balanceOf[dataKeyGt]
      ? contracts.TkgGoldBuyingAndSelling.balanceOf[dataKeyGt].value
      : null;

    setGt(res);
  }

  const fetchPal = () => {
    var res = null;

    res = contracts.TkgGoldBuyingAndSelling.showProfitAndLoss[dataKeyPal]
      ? contracts.TkgGoldBuyingAndSelling.showProfitAndLoss[dataKeyPal].value
      : [];

    setPal(res);
  }

  const fetchMp = () => {
    var res = null;

    res = contracts.TkgGoldBuyingAndSelling.showMarketPrice[dataKeyMp]
      ? contracts.TkgGoldBuyingAndSelling.showMarketPrice[dataKeyMp].value
      : [];

    setMp(res);
    setDataKeyMp(null);
  }

  const makeWillDealTokens = async (_userId, _amount, _priceForToken, _dealType) => {
    const estimatedGas = await contract.methods.willDealTokens(
          _userId, accounts[0], _amount, _priceForToken, _dealType
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const gasMultiplication = 1.2;
    const gasPriceMultiplication = 1.4;

    const _stackId = await contract.methods.willDealTokens.cacheSend(_userId, accounts[0], _amount, _priceForToken, _dealType, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*gasMultiplication),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication)
    });

    dispatch(notifyDealing(true));
    setWDStackId(_stackId);
  }

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleSubmit = e => {
    e.preventDefault();
    showGbsTransactions(userId, data.startTime, data.endTime);
    e.target.reset();
  };

  const handleChangeW = e => {
    setDataW({...dataW, [e.target.name]: e.target.value});
  };

  const handleSubmitW = (e, _dealType) => {
    var i = 0;
    const purchase = 1;
    const sell = 2;
    var _dealTypeInt = 4;
    var accumulatedYt = 0;
    var accumulatedGt = 0;

    if (_dealType === "PURCHASE")
      _dealTypeInt = purchase;
    else if (_dealType === "SELL")
      _dealTypeInt = sell;
    else {
      e.preventDefault();
      e.target.reset();
      return;
    }

    const _amount = parseInt((dataW.amount).replace(",",""));
    const _priceForToken = parseInt((dataW.priceForToken).replace(",",""));

    for (i = 0; i < wills.length; i++)
      if (parseInt(wills[i].dealType) === purchase)
        accumulatedYt += parseInt(wills[i].amount)*parseInt(wills[i].priceForToken);
      else
        accumulatedGt += parseInt(wills[i].amount);

    if ((_dealType === "PURCHASE" && accumulatedYt+_amount*_priceForToken > yt) || (_dealType === "SELL" && accumulatedGt+_amount > gt)) {
      setIsBalanceOver(true);
    }

    e.preventDefault();
    setWillDealTokens({ userId: userId, amount: _amount, priceForToken: _priceForToken, dealType: _dealTypeInt });
    setWillDealTokensModal(true);
    e.target.reset();
  };

  const handleClear = e => {
    e.preventDefault();
    setDataKeyGbsT(0);
  };

  const onClickEle = i => {
    setDealType(i);
    setOpen(!open);
  }

  const onClickDropdown = e => {
    setOpen(!open);
  }

  const willModalConfirm = e => {
    dispatch(confirmDeal(true));
  }

  const willModalCancel = e => {
    setIsBalanceOver(false);
    setWillDealTokensModal(false);
  }

  if (fetched)
    return (
      <LedgerPage
        gbsTransactions={gbsTransactions}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        handleClear={handleClear}
        handleSubmitW={handleSubmitW}
        handleChangeW={handleChangeW}
        onClickEle={onClickEle}
        onClickDropdown={onClickDropdown}
        open={open}
        yt={yt}
        gt={gt}
        dealType={dealType}
        vyen={pal.vYen}
        tkgbas={pal.tkgbas}
        mp={mp}
        willDealTokens={willDealTokens}
        willDealTokensModal={willDealTokensModal}
        willModalConfirm={willModalConfirm}
        willModalCancel={willModalCancel}
        isBalanceOver={isBalanceOver}
      />
    );
  else
    return (
      <div className="atom-spinner">
        <div className="spinner-inner">
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-line"></div>
          <div className="spinner-circle">
            &#9679;
          </div>
        </div>
       </div>
    );
}

const retrieveGt = retrieved => {
  return {
    type: LedgerActions.RETRIVED_GT,
    retrived: retrieved
  }
}

const retrieveWills = retrievedW => {
  return {
    type: LedgerActions.RETRIVED_WILLS,
    retrivedW: retrievedW
  }
}

const notifyChangingMp = changingMp => {
  return {
    type: LedgerActions.COMMITTING_CHANGING_MP,
    changingMp: changingMp
  }
}

const notifyDealing = dealing => {
  return {
    type: LedgerActions.COMMITTING_DEAL,
    dealing: dealing
  }
}

const confirmDeal = confirmedDeal => {
  return {
    type: LedgerActions.CONFIRMED_DEAL,
    confirmedDeal: confirmedDeal
  }
}

const committedDeal = confirmedDeal => {
  return {
    type: LedgerActions.COMMITTED_DEAL,
    confirmedDeal: confirmedDeal,
  }
}

const mapStateToProps = state => ({
  accounts: state.accounts,
  contracts: state.contracts,
  transactions: state.transactions,
  transactionStack: state.transactionStack,
  userId: state.login.userId,
  changingMp: state.ledger.changingMp,
  dealing: state.ledger.dealing,
  retrieved: state.ledger.retrieved,
  retrievedW: state.ledger.retrievedW,
  confirmedDeal: state.ledger.confirmedDeal
});

export default connect(mapStateToProps)(LedgerPageContainer);
